import CommonTabComp from "./CommonTabComp";

const ReceivedDocsTab = ({
  onClickSearch,
  onClickFavorite,
  onClickNewDraft,
  totalPage,
  searchResult,
}) => {
  return (
    <div style={{ minHeight: "40rem" }}>
      <CommonTabComp
        onClickSearch={onClickSearch}
        tabType="received"
        onClickFavorite={onClickFavorite}
        onClickNewDraft={onClickNewDraft}
        totalPage={totalPage}
        searchResult={searchResult}
      />
    </div>
  );
};
export default ReceivedDocsTab;
